import { INVENTORIZATION_BLOCK_IDS } from '@/features/inventorization/domain/inventorization';
import { BLOCK_STATUSES, type CaptureSession, type ValidationIssue } from '@/shared/capture/capture-session';

export function applyInventorizationReadingValidation(
  session: CaptureSession,
  issues: ValidationIssue[],
): CaptureSession {
  return {
    ...session,
    blockStatuses: {
      ...session.blockStatuses,
      [INVENTORIZATION_BLOCK_IDS.readings]: issues.length === 0 ? BLOCK_STATUSES.valid : BLOCK_STATUSES.inProgress,
    },
    validationErrors: [
      ...session.validationErrors.filter(issue => issue.blockId !== INVENTORIZATION_BLOCK_IDS.readings),
      ...issues,
    ],
  };
}
